export const SELECTIVE_PUBLIC_SUPPORT_FAQ_CATEGORIES = Object.freeze([
  'access-login',
  'privacy-consents',
  'deal-finder',
  'community-participation',
]);

const SELECTIVE_PUBLIC_SUPPORT_FAQ_CATEGORY_SET = new Set(
  SELECTIVE_PUBLIC_SUPPORT_FAQ_CATEGORIES,
);

const SELECTIVE_HIDDEN_SUPPORT_FAQ_LEGACY_SLUGS = new Set([
  'payments-and-subscriptions',
]);

export const isSupportFaqCategoryVisible = (
  category,
  { selectivePublic = false } = {},
) => {
  if (!selectivePublic) {
    return true;
  }

  return SELECTIVE_PUBLIC_SUPPORT_FAQ_CATEGORY_SET.has(category);
};

export const filterSupportFaqCategories = (
  categories,
  { selectivePublic = false } = {},
) => {
  const normalizedCategories = Array.isArray(categories) ? categories : [];
  return normalizedCategories.filter((category) =>
    isSupportFaqCategoryVisible(category, { selectivePublic }),
  );
};

export const isSelectiveHiddenSupportFaqPath = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const pathname = value.split(/[?#]/u, 1)[0].replace(/\/{2,}/gu, '/').replace(/\/+$/u, '');
  const segments = pathname.split('/').filter(Boolean);

  if (segments[0] !== 'support' || segments[1] !== 'faq' || !segments[2]) {
    return false;
  }

  return (
    !SELECTIVE_PUBLIC_SUPPORT_FAQ_CATEGORY_SET.has(segments[2]) &&
    (segments[2] === 'payments' ||
      segments[2] === 'platform-linking' ||
      SELECTIVE_HIDDEN_SUPPORT_FAQ_LEGACY_SLUGS.has(segments[2]))
  );
};
